const Utils = {
	formatCurrencyNumber(inputNumber) {
		return Number(inputNumber || 0.0)
			.toFixed(2)
			.replace(/\d(?=(\d{3})+\.)/g, "$&,");
	},
	formatPhone(inputNumber) {
		if (inputNumber === "" || inputNumber === undefined) return;
		else {
			if (inputNumber?.length < 10) return;
			else
				return `(${inputNumber.slice(0, 3)}) ${inputNumber.slice(
					3,
					6
				)}-${inputNumber.slice(6, 10)}`;
		}
	},

	dateToMMDDYYYY(dateString) {
		if (!dateString) return "";
		var parts = dateString.split("-");

		return (
			parseInt(parts[1], 10) +
			"/" +
			parseInt(parts[2], 10) +
			"/" +
			parseInt(parts[0], 10)
		);
	},

	dateToYYYYMMDD(dateString) {
		let date = new Date(dateString),
			mnth = ("0" + (date.getMonth() + 1)).slice(-2),
			day = ("0" + date.getDate()).slice(-2);
		return [date.getFullYear(), mnth, day].join("-");
	},

	textFormatted(searchInputData) {
		let data = searchInputData;
		data = data.replaceAll('$', '');
		data = data.replaceAll("\\", '');
		data = data.replaceAll("&", '');
		data = data.replaceAll(",", '');
		data = data.replaceAll("'", "\\'");
		data = data.replaceAll("*", '');
		data = data.replaceAll("@", '');
		data = data.replaceAll("#", '');
		data = data.replaceAll("%", '');
		data = data.replaceAll("!", '');
		data = data.replaceAll("+", '');
		data = data.replaceAll("=", '');
		data = data.replaceAll("~", '');
		data = data?.trim();
		return data;
	},

	ssnFormate(ssnString) {
		let ssn = ssnString,
			first = ssn.substring(0, 3),
			second = ssn.substring(3, 5),
			third = ssn.substring(5, 9);
		return [first, second, third].join("-");
	},
	feinFormate(ssnString) {
		let ssn = ssnString,
			first = ssn.substring(0, 2),
			second = ssn.substring(2);
		return [first, second].join("-");
	},
	firstSecondNameFormate(nameString) {
		let name = nameString?.split(" "),
			first = name[0],
			second = name[1] || "";
		return { firstName: first, secondname: second };
	},

	formatVendors(vendors) {
		return vendors
			? vendors.map((vendor) => ({
				value: vendor.id,
				label:
					vendor.name +
					"-" +
					vendor.billing_state +
					"-" +
					vendor.shipping_postal_code +
					"-" +
					vendor.shipping_street,
			}))
			: [];
	},

	isJsonString(text) {
		if (typeof text !== "string") {
			return false;
		}
		try {
			JSON.parse(text);
			return true;
		} catch (error) {
			return false;
		}
	},

	readFile(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => {
				if (reader.result) {
					let dataUrl = reader.result;
					let dataPart = dataUrl.substring(dataUrl.indexOf(",") + 1);
					let mimeType = dataUrl.substring(
						dataUrl.indexOf(":") + 1,
						dataUrl.indexOf(";")
					);
					resolve({ data: dataPart, mimeType: mimeType });
				}
			};
			reader.onerror = (error) => reject(error);
		});
	},
	base64ToBlob(base64, mimetype, slicesize) {
		mimetype = mimetype || "";
		slicesize = slicesize || 512;
		var bytechars = atob(base64);
		var bytearrays = [];
		for (var offset = 0; offset < bytechars.length; offset += slicesize) {
			var slice = bytechars.slice(offset, offset + slicesize);
			var bytenums = new Array(slice.length);
			for (var i = 0; i < slice.length; i++) {
				bytenums[i] = slice.charCodeAt(i);
			}
			var bytearray = new Uint8Array(bytenums);
			bytearrays[bytearrays.length] = bytearray;
		}
		return new Blob(bytearrays, { type: mimetype });
	},

	blobToLink(blob, fileName) {
		let link = document.createElement("a");
		let url = window.URL.createObjectURL(blob);
		link.href = url;
		link.download = fileName;
		return link;
	},

	urlDownloadfromLink(file_storage_url, fileName) {
		let link = document.createElement("a");
		link.href = file_storage_url;
		link.target = "_blank";
		link.download = fileName;
		return link;
	},

	compare(a, b) {
		const label1 = a.label.toLowerCase();
		const label2 = b.label.toLowerCase();
		if (label1 > label2) return 1;
		if (label2 > label1) return -1;
		return 0;
	},
};
export default Utils;
